import { Feed, Material, MaterialsService } from '../api';

interface MaterialsProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Material[] | undefined; total: number | undefined }>;
  getOne: (resource: string, params: any) => Promise<{ data: Material }>;
  create: (resource: string, params: any) => Promise<{ data: Material }>;
  update: (resource: string, params: any) => Promise<{ data: Material }>;
  delete: (resource: string, params: any) => Promise<{ data: {} }>;
  getMany: (resource: string, params: any) => Promise<{ data: Material[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: Feed[] }>;
  updateMany: (resource: string, params: any) => Promise<{ data: Material[] }>;
  deleteMany: (resource: string, params: any) => Promise<{ data: {} }>;
}

export const materialsDataProvider: MaterialsProviderResource = {
  getList: async (resource, params) => {
    const { sort, pagination } = params;
    console.log('getList', params);
    const data = await MaterialsService.getMaterials();
    if (!data) {
      return {
        data: [],
        total: 0,
      };
    }
    if (data.items && sort && sort.field) {
      data.items.sort((a: any, b: any) => {
        const aValue = a[sort.field];
        const bValue = b[sort.field];
        if (aValue === undefined || bValue === undefined) return 0;
        const order = sort.order === 'ASC' ? 1 : -1;
        if (aValue < bValue) return -1 * order;
        if (aValue > bValue) return 1 * order;
        return 0;
      });
    }
    return {
      data: data.items,
      total: data.items?.length,
    };
  },
  getOne: async (resource, params) => {
    const { id } = params;

    const feed = await MaterialsService.getMaterialById(id);
    return {
      data: feed,
    };
  },
  create: async (resource, params) => {
    const feed = await MaterialsService.createMaterial(params.data);
    return {
      data: feed,
    };
  },
  update: async (resource, params) => {
    const feed = await MaterialsService.updateMaterial(params.id, params.data);
    return {
      data: feed,
    };
  },
  delete: async (resource, params) => {
    const { id } = params;
    await MaterialsService.deleteMaterials(id);
    return {
      data: {},
    };
  },
  getMany: async (resource, params) => ({
    data: [],
  }),
  getManyReference: async (resource, params) => ({
    data: [],
  }),
  updateMany: async (resource, params) => ({
    data: [],
  }),
  deleteMany: async (resource, params) => {
    // const promises = params.ids.map((id: number) => UserService.deleteUser(id));
    const promises = params.ids.map((id: number) => console.log(id));

    await Promise.all(promises);

    return {
      data: {},
    };
  },
};
